const referral = {
  title: '推荐有礼',
  subtitle: '邀请朋友注册 EasyHireAI。第 1、3、5 个有效邀请分别为你发放一次奖励。',
  shareTitle: '分享你的专属链接',
  shareDesc: '朋友通过链接新注册并成功回跳后，会计入你的有效邀请数。',
  copy: '复制链接',
  copied: '链接已复制',
  copyFailed: '复制失败，请手动复制',
  currentCount: '有效邀请',
  peopleUnit: '人',
  nextReward: '下一档奖励',
  completed: '已完成全部奖励档位',
  programClosed: '推荐计划暂未开启，历史记录仍可查看。',
  routeTitle: '阶梯式奖励解锁路线',
  routeDesc: '达成对应有效邀请数量后，系统将自动把相应权益发放至你的账号。',
  quickShare: '快捷推广',
  shareQrTitle: '分享二维码',
  shareQrDesc: '朋友扫码即可打开你的专属邀请链接，也可以复制链接直接发送。',
  qrAlt: '推荐邀请二维码',
  downloadQr: '下载二维码',
  copyCode: '复制邀请码（{code}）',
  membershipDays: '会员时长增加',
  aiMatchPoints: 'AI积分',
  contactPoints: '联系积分',
  unlocked: '已解锁',
  inProgress: '进行中',
  rewardIssued: '奖励已自动派发',
  rulesButton: '活动规则',
  rulesTitle: '活动规则说明',
  gotIt: '我知道了',
  tipTitle: '推荐小妙招',
  tipDesc:
    '把链接分享给有招聘需求的同行。强调 EasyHireAI 的智能简历匹配与联系点权益，转化率会更高。',
  friendBenefitTitle: '好友注册也可得',
  friendBenefitDesc: '新用户通过你的链接注册后，可直接领取新用户体验权益。',
  recordsHint: '实时同步最新的邀请与结算数据',
  currentProgress: '当前进度：{current} / {total} 人',
  needMore: '还需邀请 {count} 人即可领取',
  rules: {
    rule1: '1. 有效邀请要求被邀请人通过你的专属链接完成新账号注册。',
    rule2: '2. 累计有效邀请达到对应档位后，奖励会自动发放至你的账号。',
    rule3: '3. 批量虚假注册、异常账号等无效邀请可能不会计入奖励结算。',
    rule4: '4. 推荐计划关闭时，历史邀请与奖励记录仍可查看。',
  },
  tierTitles: {
    starter: '首邀好礼',
    growth: '进阶推荐礼',
    ambassador: '推荐大使礼',
  },
  tierTags: {
    starter: '新手达标',
    growth: '人气达人',
    ambassador: '推荐大使',
  },
  rewardBundle: '会员 +{days} 天 · AI 匹配点 +{ai} · 联系点 +{contact}',
  milestoneLabel: '{count} 人邀请',
  inviteHistory: '邀请历史',
  rewardHistory: '奖励历史',
  emptyInvites: '暂无有效邀请。复制上方链接开始分享。',
  emptyRewards: '暂无奖励记录。第 1、3、5 个有效邀请会发放奖励。',
  invitedUser: '受邀账号',
  qualifiedAt: '达成时间',
  milestone: '档位',
  reward: '奖励',
  status: '状态',
  rewarded: '已发奖',
  recorded: '已记录',
  retry: '重试',
  loading: '加载中...',
  loadFailed: '推荐信息加载失败',
  inviteTitle: '好友邀请你体验 EasyHireAI',
  inviteDesc: '您获得AI Agent试用会员7天，注册后即可体验AI招聘工作台。',
  inviteCta: '注册 EasyHireAI',
  inviteCtaAuthed: '确认推荐绑定',
  inviteLoading: '正在准备邀请链接...',
  inviteAccepting: '正在确认推荐关系...',
  inviteAccepted: '推荐关系已确认',
  inviteRecorded: '已计入好友推荐进度',
  inviteRewarded: '我们提供了新手任务，体验AI招聘流程可以获得更多会员权益',
  inviteAlreadyAccepted: '该账号已确认过推荐关系',
  inviteInvalid: '邀请链接不可用或已失效',
  inviteNetworkError: '网络异常，稍后可重新打开本页面继续',
  goWorkbench: '进入工作台',
  errorCodes: {
    referral_program_closed: '推荐计划暂未开启',
    referral_invalid_code: '邀请链接不存在或已停用',
    referral_ticket_invalid: '邀请票据校验失败，请重新打开邀请链接',
    referral_ticket_expired: '邀请票据已过期，请重新打开邀请链接',
    referral_old_user: '该推荐仅统计通过本链接新注册的账号',
    referral_self_invite: '不能邀请自己',
    referral_already_attributed: '该账号已归属其他邀请人',
  },
}

export default referral
